import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { DragIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

const DragHandleIconButton = forwardRef<
  HTMLButtonElement,
  ExtendedIconButtonProps
>(({ tooltipTitle, ...props }, ref) => {
  const { t } = useTranslation();
  const resolvedTooltipTitle = tooltipTitle ?? t('common.drag', 'Drag');

  return (
    <IconButton ref={ref} {...props} tooltipTitle={resolvedTooltipTitle}>
      <DragIcon color="inherit" />
    </IconButton>
  );
});

DragHandleIconButton.displayName = 'DragHandleIconButton';
export default DragHandleIconButton;
